import React, { useEffect, useRef } from 'react'
import '../css/logo.css';
import theme from '../theme';

export default function MapControler(props) {
  
   const {googleMap, action} = props; 
   //console.debug("MapControler",action);  

   useEffect(() => {
      //console.debug(" MapControler useEffect",action);
      if(!googleMap.current) return; 

      if(action && action.type == 'center'){
         const geopoint = action.geopoint
         const center = new window.google.maps.LatLng( geopoint.latitude,  geopoint.longitude);
         googleMap.current.setCenter(center)
      }else if(action && action.type == 'zoom'){
         googleMap.current.setZoom(action.zoom)
      }

    }, [action]);
  
  

   return (
      ""
   )
}
